;(function (W, $, D, Drupal) {

  'use strict'

  if (typeof W.sg === 'undefined') {
    W.sg = {}
  }

  let sg = W.sg, $D = $(D)

  const $root = $('.paragraph--type--banniere-principale')


  let bannierePrincipale = (() => {

    /**
     * @function controlsVideo
     * Play/pause custom on video
     */
    let controlsVideo = () => {
      if($root.find('video').length > 0){
        $root.find('.play-pause-video').on('click', (e) => {
          let $btn    = $(e.currentTarget),
              player = $root.find('video')[0]

          if(player.paused) {
            player.play()
            $btn.text(Drupal.t('Pause vidéo', {}, {'context' : 'accessibilite'})).removeClass('paused')
          } else {
            player.pause()
            $btn.text(Drupal.t('Play vidéo', {}, {'context' : 'accessibilite'})).addClass('paused')
          }
        })
      }
    },
    
    reloadVideoBlazy = () => {
      if($root.find('video').length > 0 && !$root.find('video').hasClass('b-loaded') && (sg.viewport.isDesktop() || sg.viewport.isTablet())){
        Drupal.blazy.init.revalidate();
      }
    },

    oMod = {
      controlsVideo: controlsVideo,
      reloadVideoBlazy: reloadVideoBlazy
    }

    return oMod
  })()

  $D.ready(function () {
    bannierePrincipale.controlsVideo()
  }).on('sg:viewport.resize', function(){
    bannierePrincipale.reloadVideoBlazy()
  })
  
})(window, window.jQuery, document, window.Drupal)

